import { View, Text } from "@src/components";
import { StyleSheet, useUnistyles } from "react-native-unistyles";
import { FC, memo } from "react";
import { formatTime, type SegmentLabel } from "@src/features/schedules/utils/schedule-utils";
import { layoutTimeLabels } from "@src/features/schedules/utils/time-label-layout";

const LABEL_HEIGHT = 12;

interface TimeLabelsProps {
  labels: SegmentLabel[];
  barHeight: number;
}

export const TimeLabels: FC<TimeLabelsProps> = memo(({ labels, barHeight }) => {
  const { theme } = useUnistyles();

  return (
    <>
      {layoutTimeLabels(labels, { barHeight, labelHeight: LABEL_HEIGHT, gap: theme.spacing.xxs }).map((label, i) => {
        return (
          <View key={i} style={[styles.container, { top: label.top }]}>
            <View
              style={[
                styles.label,
                {
                  backgroundColor: label.isException ? (theme.colors.white[850] as string) : "transparent",
                },
              ]}
            >
              <Text textStyle="xs/regular" color={label.isException ? "black" : "text"} style={styles.labelText}>
                {formatTime(label.time.hour, label.time.minute)}
              </Text>
            </View>
          </View>
        );
      })}
    </>
  );
});

const styles = StyleSheet.create((theme) => ({
  container: {
    position: "absolute",
    left: 0,
    right: 0,
    alignItems: "center",
    zIndex: 10,
  },
  label: {
    borderRadius: theme.spacing.xl,
    borderWidth: 1,
    borderColor: theme.colors.white.default,
    minWidth: 36,
    height: LABEL_HEIGHT,
    alignItems: "center",
    justifyContent: "center",
  },
  labelText: {
    fontSize: 8,
    lineHeight: LABEL_HEIGHT - 2,
  },
}));
